import { render } from "./SideBarAsideFix.vue?vue&type=template&id=479de29e"
import script from "./SideBarAsideFix.vue?vue&type=script&lang=js"
export * from "./SideBarAsideFix.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abayomi/IdeaProjects/microservice-2/harvest-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__